/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Spinner, Text, theme } from "@nordcloud/gnui";
import { EditButton } from "~/components";
import { useToggle } from "~/hooks";
import { SelectTypeForm } from "./SelectTypeForm";

type Props = {
  id: string;
  name: string;
  isLoading: boolean;
  onChange: (id: string) => void;
};

export function InlineTypeUpdate({ id, name, onChange, isLoading }: Props) {
  const [isEditMode, toggleEditMode] = useToggle(false);

  const handleSubmit = (newTypeId: string) => {
    onChange(newTypeId);
    toggleEditMode();
  };

  if (isLoading) {
    return (
      <>
        <Spinner size="sm" />
        <Text weight="regular" tag="div" ml={theme.spacing.spacing04}>
          Loading...
        </Text>
      </>
    );
  }

  if (isEditMode) {
    return <SelectTypeForm typeId={id} onSubmit={handleSubmit} />;
  }

  return (
    <>
      <Text as="div" m="0" mr={theme.spacing.spacing02}>
        {name}
      </Text>
      <EditButton onClick={toggleEditMode} />
    </>
  );
}
